webpackJsonp([11],{

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowserDetect_vue__ = __webpack_require__(337);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290ab20d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowserDetect_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-290ab20d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowserDetect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290ab20d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowserDetect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(454);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("3f9f23ea", content, true, {});

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".mask[data-v-290ab20d]{height:45px;width:100%;text-align:center;background-color:#1f2228;-webkit-box-shadow:0 3px 6px 0 rgba(0,0,0,.11);box-shadow:0 3px 6px 0 rgba(0,0,0,.11)}.inner-mask[data-v-290ab20d]{padding:1% 2%;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.ic-novideo img[data-v-290ab20d]{height:30px;width:30px}.text-message[data-v-290ab20d]{color:#fff;font-family:ProximanovaRegular;font-size:8px;line-height:30px;margin-left:1%;white-space:nowrap}@media only screen and (min-width:600px){.text-message[data-v-290ab20d]{font-size:15px}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Header-prompt/BrowserDetect.vue"],"names":[],"mappings":"AACA,uBACC,YAAa,AACb,WAAY,AACT,kBAAmB,AACtB,yBAA0B,AAC1B,+CAAiD,AACzC,sCAAyC,CACjD,AACD,6BACI,cAAqB,AACrB,2BAA4B,AAC5B,2BAA4B,AAC5B,mBAAqB,CACxB,AACD,iCACC,YAAa,AACV,UAAY,CACf,AACD,+BACC,WAAe,AACZ,+BAAkC,AAClC,cAAe,AACf,iBAAkB,AAClB,eAAgB,AAChB,kBAAoB,CACvB,AAED,yCACA,+BACI,cAAgB,CACnB,CACA","file":"BrowserDetect.vue","sourcesContent":["\n.mask[data-v-290ab20d] {\n\theight: 45px;\n\twidth: 100%;\n    text-align: center;\n\tbackground-color: #1F2228;\n\t-webkit-box-shadow: 0 3px 6px 0 rgba(0,0,0,0.11);\n\t        box-shadow: 0 3px 6px 0 rgba(0,0,0,0.11);\n}\n.inner-mask[data-v-290ab20d]{\n    padding: 1% 2% 1% 2%;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n}\n.ic-novideo img[data-v-290ab20d] {\n\theight: 30px;\n    width: 30px;\n}\n.text-message[data-v-290ab20d]{\n\tcolor: #FFFFFF;\n    font-family: \"ProximanovaRegular\";\n    font-size: 8px;\n    line-height: 30px;\n    margin-left: 1%;\n    white-space: nowrap;\n}\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (min-width: 600px) {\n.text-message[data-v-290ab20d]{\n    font-size: 15px;\n}\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"inner-mask"},[_c('div',{staticClass:"ic-novideo"},[_c('img',{attrs:{"src":__webpack_require__(456),"alt":"noVideo"}})]),_vm._v(" "),_c('div',{staticClass:"text-message"},[_vm._v("\n            This Browser does not support the video. Please Use Chrome or Mozilla. \n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAb9JREFUSA29lT0vREEUhu9lI6IQopUtfDRWItZHQagEhUonEiqJRLQqHbVGoSERtX8gtCsh2YJCohHZXiUa63redWdNNnd2Z2WvkzyZjz3nPTPnzswGQQoWRVEvZFOQDoJY/J62CGFLk1jib/Sn/kU8Y7KQcZz+NCRtK2lOocUwDG+1cvpXMAGn8A6/hkMOPqEZK+DcDfqgqrltHwz6lcHsYIx+O6zCI/hYCadO0MoHYRFeYA7OYARKJoEpwStbfuaHhsYKTVkq4sTdKYj5ATu4zR64+gTtwAF0yYc2UTwp3isBgWuwAJlmxJXQN0EB3yXQdzKnZd2UhTmn+SbYQ8GI52K1C3az6VSOf/BN0IO/OS3z9LehD85JskLrNHOKnA5WzfM4zcAsHMIXnMA1OK1uAktcN1SCxzAJuitbusW0dc1ZIktc57wE8h2Ffcj7iONXvcnqV61GXDd0A4ZhF2Gvi2jE7BLpKD7VisdHsXJLTVAzrUnwQNAydIBOyxBo5XrEzDPC0MuSy66VQ+2ryNSfrEyUSvrzDRjYb8sR81GDtdbbVZnYm+q3kjho5a3/m9MqEb5MTTxOkCWBLlIq9g2S+mKZKa2LMAAAAABJRU5ErkJggg=="

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.8cc221bccf31aa950f29.js